import styled from 'styled-components'
import { useElementSize, useWindowSize } from 'usehooks-ts'
import { Content_DE } from './Content'

export const Learning = ({
  colorMode,
}: {
  colorMode: 'light' | 'dark' | undefined
}) => {
  const Content = Content_DE
  const { width, height } = useWindowSize()
  const isMobile = width < 712
  if (!isMobile) {
    return (
      <StyledLearning className='Learning'>
        <Row>
          <Column></Column>
          <Column>
            <StyledTitle>
              Maschinelles Lernen wird auf grosse Datenmengen angewendet
            </StyledTitle>
          </Column>
          <Column></Column>
        </Row>
        <Row>
          <StartArrow dir={'left'} />
          <FruitsUnsorted>
            <img src={require('./fruits-unsorted-01.png')} />
            <StartArrowCenter />
          </FruitsUnsorted>
          <StartArrow dir={'right'} />
        </Row>
        <Row>
          <Column>
            <StyledPathTitle>
              <div className='title'>{Content.path1.title}</div>
              <div className='lead'>{Content.path1.lead}</div>
            </StyledPathTitle>
          </Column>

          <Column>
            <StyledPathTitle>
              <div className='title'>{Content.path2.title}</div>
              <div className='lead'>{Content.path2.lead}</div>
            </StyledPathTitle>
          </Column>
          <Column>
            <StyledPathTitle>
              <div className='title'>{Content.path3.title}</div>
              <div className='lead'>{Content.path3.lead}</div>
            </StyledPathTitle>
          </Column>
        </Row>
        <Row>
          <Column>
            <ExampleTitle>
              <div className='title'>{Content.path1.example}</div>
            </ExampleTitle>
          </Column>
          <Column>
            <ExampleTitle>
              <div className='title'>{Content.path2.example}</div>
            </ExampleTitle>
          </Column>
          <Column>
            <ExampleTitle>
              <div className='title'>{Content.path3.example}</div>
            </ExampleTitle>
          </Column>
        </Row>
        <Row>
          <Column>
            <HowField>
              <Bg>
                <img src={require('./images/inputdata_1.png')} />
                <div className='title'>{Content.path1.how}</div>
              </Bg>
            </HowField>
          </Column>
          <Column>
            <HowField>
              <Bg>
                <img src={require('./images/inputdata_2.png')} />
                <div className='title'>{Content.path2.how}</div>
              </Bg>
            </HowField>
          </Column>
          <Column>
            <HowField>
              <Bg>
                <img src={require('./images/inputdata_3.png')} />
                <div className='title'>{Content.path3.how}</div>
              </Bg>
            </HowField>
          </Column>
        </Row>
        <Row>
          <Column>
            <MethodField>
              <MethodFieldBg>
                <img src={require('./images/ml_brain.png')} />
                <div className='title'>{Content.path1.method}</div>{' '}
              </MethodFieldBg>
            </MethodField>
          </Column>
          <Column>
            <MethodField>
              <MethodFieldBg>
                <img src={require('./images/ml_brain.png')} />
                <div className='title'>{Content.path2.method}</div>
              </MethodFieldBg>
            </MethodField>
          </Column>
          <Column>
            <MethodField className='_3'>
              <MethodFieldBg>
                <img src={require('./images/ml_brain.png')} />
                <div className='title _3'>{Content.path3.method}</div>

                <Path3Arrow>
                  <img
                    src={require('./images/arrow_3.png')}
                    style={{ maxWidth: '66px' }}
                  />
                  <ArrowBody />
                  <img
                    src={require('./images/arrow_3_end.png')}
                    style={{
                      maxWidth: '58px',
                      position: 'absolute',
                      top: "440px",
                      right: 0,
                    }}
                  />
                </Path3Arrow>
              </MethodFieldBg>
            </MethodField>
          </Column>
        </Row>
        <Row>
          <Column>
            <MethodDescField className='_3'>
              <MethodDescFieldBg>
                <div className='desc'>{Content.path1.methodDesc}</div>
              </MethodDescFieldBg>
            </MethodDescField>
            <StartArrowCenter minheight={100} color={'var(--purple-main)'} />
            <OutcomeImage
              src={require('./images/outcome_1.png')}
              style={{ maxWidth: '100%' }}
            />
          </Column>
          <Column>
            <MethodDescField>
              <MethodDescFieldBg>
                <div className='desc'>{Content.path2.methodDesc}</div>
              </MethodDescFieldBg>
            </MethodDescField>
            <StartArrowCenter minheight={100} color={'var(--purple-main)'} />
            <OutcomeImage
              src={require('./images/outcome_2.png')}
              style={{ maxWidth: '100%' }}
            />
          </Column>
          <Column>
            <MethodDescField>
              <MethodDescFieldBg>
                <div className='desc _3'>{Content.path3.methodDesc}</div>
              </MethodDescFieldBg>
            </MethodDescField>
            <StartArrowCenter minheight={100} color={'var(--purple-main)'} />
            <OutcomeImage
              src={require('./images/outcome_3.png')}
              style={{ maxWidth: '100%' }}
            />
          </Column>
        </Row>
        <Row>
          <Column>
            <StyledExampleTitle>
              {Content.path1.usage[0]}
              {Content.path1.usage.slice(1).map((m) => (
                <b>{m}</b>
              ))}
            </StyledExampleTitle>
          </Column>
          <Column>
            <StyledExampleTitle>
              {Content.path2.usage[0]}
              {Content.path2.usage.slice(1).map((m) => (
                <b>{m}</b>
              ))}
            </StyledExampleTitle>
          </Column>
          <Column>
            <StyledExampleTitle>
              {Content.path3.usage[0]}
              {Content.path3.usage.slice(1).map((m) => (
                <b>{m}</b>
              ))}
            </StyledExampleTitle>
          </Column>
        </Row>
      </StyledLearning>
    )
  }
  return (
    <StyledLearning>
      <FixContainer>
        <StyledTitle>
          Maschinelles Lernen wird auf grosse Datenmengen angewendet
        </StyledTitle>
        <FixHeader>
          <img src={require('./fruits-unsorted-01.png')} /> <StartArrowCenter />
        </FixHeader>
        {[Content.path1, Content.path2].map((path, i) => {
          return (
            <Row>
              <FixContent>
                <StyledPathTitle>
                  <div className='title'>{path.title}</div>
                  <div className='lead'>{path.lead}</div>
                </StyledPathTitle>
                <ExampleTitle>
                  <div className='title'>{path.example}</div>
                </ExampleTitle>
                <HowField>
                  <Bg>
                    <img
                      src={require('./images/inputdata_' + (i + 1) + '.png')}
                    />
                    <div className='title'>{path.how}</div>
                  </Bg>
                </HowField>
                <MethodField>
                  <MethodFieldBg>
                    <img src={require('./images/ml_brain.png')} />
                    <div className='title'>{path.method}</div>
                  </MethodFieldBg>
                </MethodField>
                <MethodDescField>
                  <MethodDescFieldBg>
                    <div className='desc'>{path.methodDesc}</div>
                  </MethodDescFieldBg>
                </MethodDescField>
                <StartArrowCenter
                  minheight={70}
                  color={'var(--purple-main)'}
                />
                <Center>
                  <OutcomeImage
                    src={require('./images/outcome_' + (i + 1) + '.png')}
                    style={{ maxWidth: '100%' }}
                  />
                </Center>
                <StyledExampleTitle>
                  {path.usage[0]}
                  {path.usage.slice(1).map((m) => (
                    <b>{m}</b>
                  ))}
                </StyledExampleTitle>
              </FixContent>
            </Row>
          )
        })}
      </FixContainer>
      <Row>
        <FixContent>
          <StyledPathTitle>
            <div className='title'>{Content.path3.title}</div>
            <div className='lead'>{Content.path3.lead}</div>
          </StyledPathTitle>
          <ExampleTitle>
            <div className='title'>{Content.path3.example}</div>
          </ExampleTitle>
          <HowField>
            <Bg>
              <img src={require('./images/inputdata_3.png')} />
              <div className='title'>{Content.path3.how}</div>
            </Bg>
          </HowField>
          <MethodField>
            <MethodFieldBg>
              <img src={require('./images/ml_brain.png')} />
              <div className='title'>{Content.path3.method}</div>
                 <Path3Arrow>
                  <img
                    src={require('./images/arrow_3.png')}
                    style={{ maxWidth: '65px' }}
                  />
                  <ArrowBody />
                  <img
                    src={require('./images/arrow_3_end.png')}
                    style={{
                      maxWidth: '59px',
                      position: 'absolute',
                      top: "440px",
                      right: 0,
                    }}
                  />
                </Path3Arrow>
            </MethodFieldBg>
          </MethodField>
          <MethodDescField>
            <MethodDescFieldBg>
              <div className='desc'>{Content.path3.methodDesc}</div>
            </MethodDescFieldBg>
          </MethodDescField>
          <StartArrowCenter minheight={70} color={'var(--purple-main)'} />
          <Center>
            <OutcomeImage
              src={require('./images/outcome_3.png')}
              style={{ maxWidth: '100%' }}
            />
          </Center>
          <StyledExampleTitle>
            {Content.path3.usage[0]}
            {Content.path3.usage.slice(1).map((m) => (
              <b>{m}</b>
            ))}
          </StyledExampleTitle>
        </FixContent>
      </Row>
    </StyledLearning>
  )
}

const StyledExampleTitle = styled.div`
  flex: 0 0 33.33%;
  font-family: var(--font-sans-serif);
  text-align: left;
  line-height: 1.3em;
  margin-top: 15px;
  margin-bottom: 30px;
  font-size: 14px;
  padding-top: 15px;
  border-top: 1px solid var(--brandblue-bright-3);

  @media only screen and (max-width: 711px) {
    text-align: center;
    border-top: 0;
    margin-top: 0;
  }
  b {
    margin-top: 5px;
    display: inline-block;
    width: 100%;
    font-size: 15px;
  }
`

const OutcomeImage = styled.img`
  margin-top: 15px;
`
const Row = styled.div`
  display: flex;
  gap: 15px;
  min-height: 100%;
`
const Column = styled.div`
  flex: 0 0 calc(33.333% - 15px);
`
const ExampleTitle = styled.div`
  width: calc(100% - 30px);
  font-family: var(--font-sans-serif);
  text-align: center;
  line-height: 1.3em;
  font-size: 14px;
  padding: 15px;
  padding-bottom: 0;
  background-color: var(--brandblue-bright-5);
  color: var(--brandblue-main);
  height: 100%;
  min-height: 6em;
  b {
    margin-top: 5px;
    display: inline-block;
    width: 100%;
    font-size: 15px;
  }
  @media only screen and (max-width: 711px) {
    min-height: unset;
    padding-bottom:15px;

  }
`
const Bg = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--brandblue-bright-4);
  padding: 15px;
  padding-bottom: 0;
  color: var(--brandblue-main);
`
const HowField = styled.div`
  width: calc(100% - 30px);
  font-family: var(--font-sans-serif);
  text-align: center;
  line-height: 1.3em;
  font-size: 15px;
  height: 100%;
  position: relative;
  min-height: 100%;
  .title {
    padding-bottom: 30px;
  }
  img {
    /* width: 220px; */
    max-width: 100%;
  }
  &::after {
    content: '';
    display: inline-block;
    width: 75px;
    height: 80px;
    background-image: url(${require('./images/round_arrow_right.png')});
    position: absolute;
    bottom: -80px;
    left: 0;
  }
`

const MethodField = styled.div`
  width: calc(100% - 30px);
  font-family: var(--font-sans-serif);
  text-align: center;
  line-height: 1.3em;
  font-size: 15px;
  height: 100%;
  position: relative;
  margin-top: 100px;
  padding-bottom: 15px;
  ._3 {
    padding-right: 30px !important;
  }
  img {
    width: 100px;
    margin-top: -80px;
    margin-bottom: 15px;
  }
  b {
    margin-top: 5px;
    display: inline-block;
    width: 100%;
    font-size: 15px;
  }
  @media only screen and (max-width: 711px) {
    padding-bottom: 0;


  }
`
const MethodDescField = styled.div`
  width: calc(100% - 30px);
  font-family: var(--font-sans-serif);
  text-align: center;
  line-height: 1.3em;
  font-size: 15px;
  height: 140px;
  position: relative;
  @media only screen and (max-width: 711px) {
    height: unset;
    /* padding-bottom: 15px; */
  }
`
const Center = styled.div`
  text-align: center;
  width: 100%;
`
const MethodDescFieldBg = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--purple-main);
  padding: 15px;
  color: #fff;
  .desc._3 {
    padding-right: 30px !important;
  }
  @media only screen and (max-width: 711px) {
    /* padding-top: 30px; */
  
    padding-bottom: 30px;
  }
`
const MethodFieldBg = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--purple-bright-1);
  padding: 15px;
  padding-bottom: 0;
  color: #fff;
  @media only screen and (max-width: 711px) {
    padding-bottom: 15px;
      /* padding-bottom: 0; */

  }
`

const ArrowBody = styled.div`
  display: inline-block;
  width: 26px;
  height: 360px;
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  background-color: var(--brandblue-bright-4);
`
const Path3Arrow = styled.div`
  position: absolute;
  right: 0;
  top: 0px;
`
const FixContainer = styled.div`
  /* min-height: 100vh; */
  flex: 0 0 100%;
`
const FixHeader = styled.div`
  /* position: sticky; */
  top: 0;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: var(--site-background);
  z-index: 12;
  margin-top: 35%;
  img {
    margin-top: -42%;
    max-width: 200px;
  }
`
const FixContent = styled.div`
  padding-top: 30px;
  padding-bottom: 60px;
  border-top: 3px solid var(--brandblue-bright-1);
  height: 100%;
  overflow: hidden;
`

const StyledTitle = styled.div`
  font-family: var(--font-sans-serif);
  text-align: left;
  line-height: 1.3em;
  width: 100%;
  text-align: center;
  padding-bottom: 30px;
`
const StyledPathTitle = styled.div`
  flex: 0 0 calc(33.33% - 15px);
  font-family: var(--font-sans-serif);
  text-align: left;
  line-height: 1.3em;
  margin-top: 15px;
  margin-bottom: 30px;
  span {
    display: inline-block;
    width: 100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 2em;
    font-style: italic;
  }
  .title {
    font-weight: 700;
    margin-bottom: 5px;
    font-size: 22px;
  }
  .lead {
    font-size: 15px;
    /* padding-left: 20px;
  */
    padding-right: 20px;
  }
  .outcome {
    font-size: 15px;
    padding-left: 10vw;
    padding-right: 10vw;
  }

  @media only screen and (max-width: 711px) {
    .title,
    .lead {
      text-align: center;
    }
  }
`
const StyledLearning = styled.div`
  margin-bottom: 60px;
  max-width: 100%;
`

const FruitsUnsorted = styled.div`
  flex: 0 0 33.33%;
  text-align: center;
  img {
    height: 200px;
  }
`

/*


StartArrows


*/
const triangle = 4
const EndMarker = ({ id, color }: { id: string; color?: string }) => {
  return (
    <defs>
      <marker
        id={id}
        viewBox={`0 0 ${triangle} ${triangle}`}
        refX={0}
        refY={triangle / 2}
        markerUnits='strokeWidth'
        markerWidth={triangle}
        markerHeight={triangle}
        orient='auto'
      >
        <Arrow
          d={`M 0 0 L ${triangle} ${triangle / 2} L 0 ${triangle} z`}
          fill={color}
        />
      </marker>
    </defs>
  )
}
const StartArrowCenter = ({
  pos = 0.5,
  minheight,
  color = 'var(--brandblue-bright-3)',
}: {
  pos?: number
  minheight?: number
  color?: string
}) => {
  const [ref, { width, height }] = useElementSize()
  const rndid = 'triangle_' + Math.random()
  return (
    <SVGWrapperCenter
      ref={ref}
      className='StartArrowCenter'
      style={{ minHeight: minheight ? minheight + 'px' : 'unset' }}
    >
      <svg width='100%' height={minheight ? minheight : '50px'}>
        <EndMarker color={color} id={rndid} />
        <ArrowLine
          d={`M${width * pos} 0 L${width * pos} ${
            (minheight || height) - triangle * 4
          }`}
          markerEnd={'url(#' + rndid + ')'}
          stroke={color}
        />
      </svg>
    </SVGWrapperCenter>
  )
}
const StartArrow = ({
  dir,
  color = 'var(--brandblue-bright-3)',
}: {
  dir: 'left' | 'right'
  color?: string
}) => {
  const [ref, { width, height }] = useElementSize()
  const rndid = 'triangle_' + Math.random()

  const rad = height / 4

  const start = dir === 'left' ? [width, height / 2] : [0, height / 2]

  const turnStart =
    dir === 'left'
      ? [width * 0.5 + rad, height / 2]
      : [width * 0.5 - rad, height / 2]
  const turnEnd = [width * 0.5, height / 2 + rad]

  const end = [width * 0.5, height - triangle * 4]

  const path =
    `M${start[0]} ${start[1]}` +
    ` L${turnStart[0]} ${turnStart[1]} ` +
    `A${rad} ${rad} 0 0 ${dir === 'left' ? 0 : 1} ${turnEnd[0]} ${
      turnEnd[1]
    } ` +
    `L${end[0]} ${end[1]}`

  return (
    <SVGWrapper ref={ref}>
      <svg width='100%' height='100%'>
        <EndMarker color={color} id={rndid} />
        <ArrowLine d={path} markerEnd={'url(#' + rndid + ')'} stroke={color} />
      </svg>
    </SVGWrapper>
  )
}

const SVGWrapperCenter = styled.div`
  width: 100%;
  height: 50px;
`
const SVGWrapper = styled.div`
  width: 100%;
  height: 250px;
`
const Arrow = styled.path`
  /* fill: var(--brandblue-bright-2); */
`
const ArrowLine = styled.path`
  stroke-width: 4;
  /* stroke: var(--brandblue-bright-2); */
  fill: none;
`
